import { Component, Input, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReviewWrapperComponent } from '../../../ui/review-wrapper/review-wrapper.component';
import { RecipientForm } from '../../../../services/campaign/recipients.service';
import { WizardAudienceService } from '../../../../pages/organization/campaigns/create-campaign/wizard-audience.service';
import { formatCount } from '../../../../../utils/sms';

@Component({
  selector: 'app-recipients-review',
  standalone: true,
  imports: [ReviewWrapperComponent],
  templateUrl: './recipients-review.component.html',
  styleUrl: '../campaign-review.css',
})
export class RecipientsReviewComponent {
  @Input() recipients!: RecipientForm;
  /** Unique recipients as last counted (RecipientsService.totalRecipientsCount). */
  @Input() totalContacts!: number;
  audience = inject(WizardAudienceService);

  readonly formatCount = formatCount;

  constructor(private router: Router, private route: ActivatedRoute) {}

  /** "2 organizations, 3 tags and 1 segment". */
  get groupSummary(): string {
    const parts = [
      this.count(this.recipients?.organizations?.length ?? 0, 'organization', 'organizations'),
      this.count(this.recipients?.tags?.length ?? 0, 'tag', 'tags'),
      this.count(this.recipients?.segments?.length ?? 0, 'segment', 'segments'),
    ].filter(Boolean) as string[];
    if (!parts.length) return 'no groups';
    return parts.length > 1 ? `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}` : parts[0];
  }

  private count(n: number, one: string, many: string): string | null {
    return n ? `${formatCount(n)} ${n === 1 ? one : many}` : null;
  }

  navigateToUrl() {
    this.router.navigate([], {
      relativeTo: this.route, // Stay on the current route
      queryParams: { step: 'recipients' }, // Add the new query param
    });
  }
}
